import { RemoteGetAllPersonsFromGroup } from 'data/usecases';
import { GetAllPersonsFromGroupUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPersonsFromGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllPersonsFromGroup =
  (): GetAllPersonsFromGroupUseCaseInterface =>
    new RemoteGetAllPersonsFromGroup(
      makeApiUrlPersonsFromGroup(),
      makeAxiosHttpClient(),
    );
